export default "__VITE_ASSET__k8So$$GE__"